interface DiscardConfirmProps {
  onKeep: () => void;
  onDiscard: () => void;
}

/** Small "are you sure" card shown on top of a pop-up that has typed-in changes. */
export function DiscardConfirm({ onKeep, onDiscard }: DiscardConfirmProps) {
  return (
    <div
      className="absolute inset-0 z-10 flex items-center justify-center bg-black/30 p-4"
      data-testid="discard-confirm"
    >
      <div
        role="alertdialog"
        aria-label="Discard what you typed?"
        className="w-full max-w-sm rounded-xl border border-[var(--border-primary)] bg-[var(--bg-surface)] p-5 shadow-xl"
      >
        <h3 className="text-base font-semibold text-[var(--text-primary)]">Discard what you typed?</h3>
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" className="rounded-lg border border-[var(--border-primary)] px-4 py-2 text-sm font-medium text-[var(--text-secondary)] hover:bg-[var(--bg-surface-hover)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ink-0)] focus-visible:ring-offset-2" autoFocus onClick={onKeep}>
            Keep editing
          </button>
          <button type="button" className="rounded-lg bg-[var(--ink-0)] px-4 py-2 text-sm font-medium text-white hover:bg-[var(--ink-1)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ink-0)] focus-visible:ring-offset-2" onClick={onDiscard}>
            Discard
          </button>
        </div>
      </div>
    </div>
  );
}
